'use client';

import { useTranslations } from 'next-intl';
import { ServicesDataProvider } from './ServicesDataContext';
import { ServicesCardsSection } from './sections/ServicesCardsSection';

export default function ServicesContent() {
  const t = useTranslations('Services');

  return (
    <div className=" px-4 sm:px-6 lg:px-8 bg-white">
        {/* Services grid */}
        <ServicesDataProvider>
          <ServicesCardsSection />
        </ServicesDataProvider>
    </div>
  );
}
